import { createFileRoute } from "@tanstack/react-router";
import DonateHub from "@project/donate/pages/hub/index";

export const Route = createFileRoute("/donate/")({
  head: () => ({
    meta: [
      { title: "Donate — Jivandhara" },
      {
        name: "description",
        content:
          "Support elder care, food, medical and welfare at Jivandhara. Choose a cause and donate online with 80G receipt.",
      },
    ],
  }),
  component: DonateHub,
});
